import React from 'react';
import { string, func } from 'prop-types';

import Checkbox from '../common/Checkbox';

const StudentsReportType = ({ type, onChange }) => (
  <div>
    <Checkbox
      input={{
        value: type === 'basic',
        onChange: () => onChange('basic')
      }}
      label="Completo"
      meta={{ touched: false }}
      radio
    />
    <Checkbox
      input={{
        value: type === 'reduced',
        onChange: () => onChange('reduced')
      }}
      label="Reducido"
      meta={{ touched: false }}
      radio
    />
  </div>
);

StudentsReportType.propTypes = {
  type: string.isRequired,
  onChange: func.isRequired
};

export default StudentsReportType;



// WEBPACK FOOTER //
// ./src/components/report/StudentsReportType.js